import { Controller } from "@hotwired/stimulus"

const LOADED_PAGES_RANGE = 10

export default class extends Controller {
  static outlets = ['slide-image', 'page-info']

  initialize() {
    // Thanks to: https://ics.media/entry/190902/
    this.intersectionObserver = new IntersectionObserver(this.#changePage, { rootMargin: '-50% 0px' })
  }

  slideImageOutletConnected(outlet, element) {
    this.intersectionObserver.observe(element)
  }

  slideImageOutletDisconnected(outlet, element) {
    this.intersectionObserver.unobserve(element)
  }

  #changePage = entries => {
    const intersecting = entries.find(entry => entry.isIntersecting)

    if (intersecting) {
      const slideImage = this.slideImageOutlets.find(v => v.element === intersecting.target)

      this.pageInfoOutlet?.updatePage(slideImage.pageValue)
      this.#loadImages(slideImage)
    }
  }

  #loadImages(base) {
    const from = Math.max(1, base.pageValue - LOADED_PAGES_RANGE)
    const to = Math.min(base.pageValue + LOADED_PAGES_RANGE, this.slideImageOutlets.length)

    this.slideImageOutlets.filter(v => v.pageValue >= from && v.pageValue <= to).forEach(v => v.load())
  }
}
